export default "__VITE_ASSET__C5dd0VOP__"